import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import './style.css';
import CONTACT_CONFIG from '../../configs/contactConfig';

const { PT_CONTACT, FOOTER_CONTACT } = CONTACT_CONFIG;

export const Footer = () => (
  <>
    <div className="footer py-10">
      <div className="container mx-auto">
        <div className="px-8 lg:px-0 lg:flex lg:justify-between">
          <div>
            <p className="text-lg text-blue-light40 font-medium">Office</p>
            <p className="text-base font-semibold py-3 lg:py-2">Head Office (Surabaya)</p>
            <p>
              IdeaHub Voza Tower, lantai 20
              <br />
              Jl. Mayjen HR. Muhammad No.31
              <br />
              Sukomanunggal, Surabaya
              <br />
              Jawa Timur, 60189
            </p>
            <p className="text-base font-semibold py-3 lg:py-2 lg:mt-5">Branch Office ( Jakarta )</p>
            <p>
              GoWork Sampoerna Strategic
              <br />
              Square (North Tower), Lantai 12
              <br />
              Jl. Jend. Sudirman Kav.45 Karet
              <br />
              Semanggi Setiabudi,
              <br />
              Jakarta Selatan, 12930
            </p>
          </div>
          <div className="grid py-8 lg:py-0 lg:hidden">
            <p className="text-lg text-blue-light40 font-medium">Menu</p>
            <a href="/peluang-deposito" className="pt-4">Peluang Deposito</a>
            <a href="/kalkulator" className="pt-4">Kalkulator</a>
            <a href="/promo" className="pt-4">
              <span className="flex items-center">Promo <div className="new-badge ml-1">Baru</div></span>
            </a>
            <a href="/blog" className="pt-4">Blog</a>
            <a href="/faq" className="pt-4">FAQ</a>
            <a href="/hubungi-kami" className="pt-4">Hubungi Kami</a>
            <a href="/pages/syarat-ketentuan" className="pt-4">Syarat dan Ketentuan</a>
          </div>
          <div className="my-5 lg:my-0">
            <p className="text-lg text-blue-light40 font-medium">Phone</p>
            <div className="grid">
              <div className="py-2">
                <p className="text-sm lg:text-base font-medium">Office</p>
                <p className="text-sm lg:text-base">{FOOTER_CONTACT.PHONE}</p>
              </div>
              <div className="py-2">
                <p className="text-sm lg:text-base font-medium">Whatsapp</p>
                <a className="text-sm lg:text-base lg:py-2" href={FOOTER_CONTACT.WHATSAPP_LINK} target="_blank" rel="noreferrer">
                  {FOOTER_CONTACT.WHATSAPP}
                </a>
              </div>
              <div className="py-7 lg:py-4">
                <p className="text-lg text-blue-light40 font-medium py-3">E-mail</p>
                <a className="text-blue-soft" href={`mailto:${PT_CONTACT.EMAIL}`}>{PT_CONTACT.EMAIL}</a>
              </div>
            </div>
            <p className="text-lg text-blue-light40 font-medium mt-8 lg:mt-0 py-5 lg:py-4">Follow Us On</p>
            <div className="flex lg:justify-between">
              <a
                href="https://www.youtube.com/channel/UCzdxX1sq7jl4kli5XMzdqvQ"
                target="_blank"
                rel="noreferrer noopener"
              >
                <StaticImage
                  src="../../images/sosmed-3.png"
                  alt="youtube-logo"
                  objectFit="contain"
                  placeholder="none"
                  className="w-12"
                />
              </a>
              <a
                href="https://www.tiktok.com/@depositobpr.id"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="facebook-komunal"
              >
                <StaticImage
                  src="../../images/sosmed-1.png"
                  alt="youtube-logo"
                  objectFit="contain"
                  placeholder="none"
                  className="w-12 ml-4"
                />
              </a>
              <a
                href="https://twitter.com/komunal_id"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="twitter-komunal"
              >
                <StaticImage
                  src="../../images/sosmed-4.png"
                  alt="youtube-logo"
                  objectFit="contain"
                  placeholder="none"
                  className="w-12 ml-4"
                />
              </a>
              <a
                href="https://www.instagram.com/komunal.id/"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="instagram-komunal"
              >
                <StaticImage
                  src="../../images/sosmed-2.png"
                  alt="youtube-logo"
                  objectFit="contain"
                  placeholder="none"
                  className="w-12 ml-4"
                />
              </a>
            </div>
          </div>
          <div className="lg:grid py-8 lg:py-0 hidden">
            <p className="text-lg text-blue-light40 font-medium">Menu</p>
            <a href="/peluang-deposito" className="pt-4">Peluang Deposito</a>
            <a href="/kalkulator" className="pt-4">Kalkulator</a>
            <a href="/promo" className="pt-4">
              <span className="flex items-center">Promo <div className="new-badge ml-1">Baru</div></span>
            </a>
            <a href="/blog" className="pt-4">Blog</a>
            <a href="/faq" className="pt-4">FAQ</a>
            <a href="/hubungi-kami" className="pt-4">Hubungi Kami</a>
            <a href="/pages/syarat-ketentuan" className="pt-4">Syarat dan Ketentuan</a>
          </div>
          <div className="my-14 lg:my-0">
            <p className="text-lg text-blue-light40 font-bold">Terdaftar dan diawasi OJK</p>
            <p className="text-base font-normal py-4">No. S-576/IK.01/2024</p>
            <p className="text-lg text-blue-light40 font-medium mt-8 lg:mt-0">Terdaftar di</p>
            <div className="flex py-4">
              <StaticImage
                src="../../images/kominfo-footer.png"
                alt="kominfo-logo"
                objectFit="contain"
                className="w-12"
                placeholder="none"
              />
              <StaticImage
                src="../../images/fintech-footer.png"
                alt="fintech-logo"
                objectFit="contain"
                className="w-20 ml-3 lg:ml-4"
                placeholder="none"
              />
            </div>
            <p className="text-lg text-blue-light40 font-medium py-4 mt-8 lg:mt-0">Telah Tersertifikasi</p>
            <StaticImage
              src="../../images/cbqa-iso-27001.webp"
              alt="setifikasi"
              objectFit="contain"
              className="w-14"
              placeholder="none"
            />
          </div>
        </div>
      </div>
    </div>
    <div className="bg-blue-light40">
      <div className="container mx-auto text-center text-white text-xs py-6 lg:py-4">
        Powered By
        <div>
          <StaticImage
            src="../../images/komunal-footer.png"
            alt="komunal-footer"
            objectFit="contain"
            className="w-24 lg:mt-2"
            placeholder="none"
          />
        </div>
      </div>
    </div>
  </>
);

export default Footer;
